/**
 * 工具类
 * @type {boolean}
 */
import axios from 'axios'
import {Loading, Message} from 'element-ui';

// const baseUrl = "https://zyjwsys.sxsla.cn/";
const baseUrl = "https://api.impr.com.cn/";
 // const baseUrl = "http://192.168.1.8:11056/";
// const baseUrl = "http://192.168.6.7:10078/";
// const baseUrl = "http://192.168.1.10:10077/";
// const baseUrl = "http://192.168.1.7:10077/";

const option = {
    lock: true,
    text: '拼命加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.2)' 
};

let instance = axios.create({
    baseURL: baseUrl,
    timeout: 6000, // 请求超时日期
});


let isShowLog = true //是否显示日志

function getCookie(key) {
    let arr = document.cookie.split(";"); //[csrfToken=]
    let val = "";
    arr.forEach(item => {
        let bArr = item.split("="); //[csrfToken=]
        if (bArr[0] === key) {
            val = bArr[1]
        }
    })
    return val
}

// // 添加请求拦截器
// instance.interceptors.request.use(function (config) {
//     // 在发送请求之前做些什么
//     //前端登录成功放token  x-csrf-token
//     //console.log(config)
//     //登录和注册不需要token 拦截前端请求
//     let writePath = ['/api/login', '/api/registry'];
//     return writePath.includes(config.url) ? {
//         ...config,
//         headers: {
//             ...config.headers,
//             //把token取出来就带过去了,通过document.cookie可以拿到x-csrf-token的值
//             "x-csrf-token": getCookie('csrfToken') //取出来csrfToken
//         }
//     } : {
//         ...config,
//         headers: {
//             ...config.headers,
//             //把token取出来就带过去了,通过document.cookie可以拿到x-csrf-token的值
//             "x-csrf-token": getCookie('csrfToken'),//取出来csrfToken
//             token: window.localStorage.getItem('token')
//         }
//     }
// }, function (error) {
//     // 对请求错误做些什么
//     return Promise.reject(error);
// });
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default {
    Logger(content) {
        if (isShowLog) {
            console.log(content);
        }
    },
	formatTime(value) {
		if (value) {
			// let date = new Date(value * 1000) // 时间戳为秒：10位数
			let date = new Date(parseInt(value))	// 时间戳为毫秒：13位数
			let year = date.getFullYear()
			let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
			let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
			let hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
			let minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
			let second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`
		} else {
			return ''
		}
	},
    showMessage(type, message) {
        var duration = 1000;
        var offset = 400;
        var iscenter = true;
        if (type == "error") {
            Message.error({
                center: iscenter,
                duration: duration,
                offset: offset,
                message: message
            });
        } else if (type == "success") {
            Message.success({
                center: iscenter,
                duration: duration,
                offset: offset,
                message: message
            });
        } else {
            Message({
                center: iscenter,
                duration: duration,
                offset: offset,
                message: message
            });
        }
    },
    requestGet(that, url, dataBean, callback, errCallback) {
        let loading = Loading.service(option);
        // this.Logger("11111111111111111")
        instance.get(url, {params: dataBean}).then(res => {
            utils.logger(JSON.stringify(res))
            // callback(res.data)
            loading.close();
            if (res.data.code === 200) {
                callback(res.data.data, res.data.total);
            } else {
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: res.data.msg ? res.data.msg : "服务异常，请稍后重试"
                });
                if (errCallback)
                    errCallback();
            }
        }).catch(e => {
            loading.close();
            if (e.response.status && e.response.status == 400)
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: "参数错误"
                });
            else
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: "服务异常，请稍后重试"
                });
            this.Logger(e)
            if (errCallback)
                errCallback();
        })
    },
    requestPost(that, url, dataBean, callback, errCallback) {
        let loading = Loading.service(option);
        instance.post(url, dataBean).then(res => {
            loading.close();
            // this.Logger(JSON.stringify(res))
            if (res.data.code === 200) {
                callback(res.data.data, res.data.total);
            } else {
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: res.data.msg ? res.data.msg : "服务异常，请稍后重试"
                });
                if (errCallback)
                    errCallback();
            }
        }).catch(e => {
            loading.close();
            if (e.response.status && e.response.status == 400)
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: "参数错误"
                });
            else
                that.$message.error({
                    center: true,
                    offset: 400,
                    message: "服务异常，请稍后重试"
                });
            this.Logger(e);
            if (errCallback)
                errCallback();
        })
    }
}
